import React, { useCallback, useEffect, useState } from "react";
import { useProspectionPageStyles } from "./index.styles";
import { ProspectionTable } from "./Table";
import { ProspectionDrawer } from "./Drawer";
import {
  Button,
  Card,
  Field,
  Input,
  Radio,
  RadioGroup,
  Spinner,
} from "@fluentui/react-components";
import { formatAsCnpj, IntervalOptions, stripCnpj } from "Utils";
import {
  useGetBasicCnpjInfo,
  useGetListProspects,
} from "hooks/Prospection/useProspectionSearch";
import { SearchState } from "Pages/Search/index.types";
import { WarningToast } from "Components/MessageBars/toasts";
import { useAppToast } from "hooks/Toast/useAppToast";
import { noop } from "lodash";
import { useAmpli } from "hooks/useAmpli";

export default function ProspectionPage() {
  const styles = useProspectionPageStyles();
  const { tracker } = useAmpli();
  const [interval, setInterval] = useState<Number>(2);
  const {
    useToastController: { dispatchToast },
  } = useAppToast();

  const [searchState, setSearchState] = useState<SearchState>({
    searchParams: {
      doc: "",
      isCnpjValid: false,
    },
  });

  const cnpjFieldMessage =
    searchState.searchParams.doc == ""
      ? ""
      : searchState.searchParams.isCnpjValid
        ? null
        : "Digite um numero CNPJ valido.";

  const {
    isFetching,
    isFetched: isProspectUpdated,
    refetch: getBasicCnpjInfoRefetch,
  } = useGetBasicCnpjInfo(searchState.searchParams.doc, interval);

  const {
    data: prospectList,
    isFetched,
    isFetching: isFetchingAllList,
    refetch: refetchList,
  } = useGetListProspects();

  useEffect(() => {
    if (isProspectUpdated == true) refetchList();
  }, [isProspectUpdated]);

  if (!isFetched) {
    return (
      <div className={styles.container}>
        <Card style={{ width: "100%" }}>
          <Spinner />
        </Card>
      </div>
    );
  }

  const doSearch = async () => {
    tracker.search({
      document: searchState.searchParams.doc,
      types: ["prospection", `${interval.toString()} years`],
    });
    if (
      isFetched &&
      prospectList.find(
        (company) => company.cnpj == stripCnpj(searchState.searchParams.doc)[0],
      )
    ) {
      {
        dispatchToast(
          <WarningToast
            subtitle={`Documento numero ${searchState.searchParams.doc}`}
            message="CNPJ ja pesquisado."
          />,
          {
            intent: "warning",
            timeout: 2000,
          },
        );
        return;
      }
    }
    await getBasicCnpjInfoRefetch();
  };

  //   data,
  //   refetch: doSearch,
  //   isFetching,
  //   error,
  // } = useProspectionSearch({ ...searchState, searchInterval: interval }, false);

  return (
    <>
      <div className={styles.container}>
        <Card style={{ width: "35%" }}>
          <Field
            validationState={
              searchState.searchParams.doc == ""
                ? "none"
                : searchState.searchParams.isCnpjValid == true
                  ? "none"
                  : "error"
            }
            label="Numero CNPJ:"
            validationMessage={cnpjFieldMessage}
          >
            <Input
              value={searchState.searchParams.doc}
              maxLength={18}
              onChange={(_, data) => {
                const [cnpj, isValid] = formatAsCnpj(data.value);
                setSearchState((prev) => ({
                  ...prev,
                  searchParams: {
                    doc: cnpj,
                    isCnpjValid: isValid,
                  },
                }));
              }}
            />
          </Field>
          <Field label="Periodo">
            <RadioGroup
              onChange={(_, data) => setInterval(Number(data.value))}
              value={interval?.toString()}
              required
              layout="horizontal"
              // className={cardStyles.sideBySideRadio}
            >
              {IntervalOptions.map((option) => (
                <Radio
                  checked={option.Value == interval}
                  key={option.Value}
                  value={option.Value.toString()}
                  label={option.Label}
                />
              ))}
            </RadioGroup>
          </Field>
          <Button
            disabled={!!isFetching || !searchState.searchParams.isCnpjValid}
            onClick={() => doSearch()}
            appearance="primary"
          >
            Pesquisar
          </Button>
          {isFetching && <Spinner />}
        </Card>

        <Card style={{ width: "100%" }}>
          <ProspectionTable
            {...{
              prospectList,
            }}
          />
        </Card>
      </div>
    </>
  );
}
